import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDeleteDirectMessagePayload {
    data: {
        username?: string
        roomId?: string
    }
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: [],
    errors: null
}

const deleteDirectMessageSlice = createSlice({
    name: 'chat/delete-direct-message',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDeleteDirectMessagePayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.messages
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const deleteDirectMessageActions = deleteDirectMessageSlice.actions
export default deleteDirectMessageSlice.reducer
